/*
        This generates unique IDs.
        It's not safe if you are generating 1000s of IDs, but it should
        be fine if making a few IDs for component keys.

        taken from: https://gist.github.com/gordonbrander/2230317

        If I start having issues with uniqueness, I can try another approach.
        http://fiznool.com/blog/2014/11/16/short-id-generation-in-javascript/
    */
const ShortId = () => `_${Math.random().toString(36).substr(2, 9)}`;
export default ShortId;
